import { useSeo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { ProjectCard } from "@/components/ProjectCard";
import { PROJECTS } from "@/data/content";

export default function ProjectsPage() {
  useSeo({
    title: "Selected Projects | Jaybhaye Realty Pvt. Ltd. — Aurangabad & Pune",
    description:
      "Delivered landmarks by Apratim Group — Apratim Radhai Estate, Apratim Park (Beed Bypass) and Apratim Vastu in Chhatrapati Sambhaji Nagar — and upcoming Jaybhaye Realty developments across Pune.",
    path: "/projects",
    keywords:
      "Jaybhaye Realty projects, Apratim Radhai Estate, Apratim Park Beed Bypass, Apratim Vastu Aurangabad, Jaybhaye Realty Pune projects",
  });

  return (
    <div data-testid="projects-page">
      <section className="py-24 border-b border-[#12281a]/15">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <span className="text-xs uppercase tracking-[0.3em] text-[#b38b47] font-bold block mb-6">Portfolio</span>
          <h1 className="font-monument text-4xl sm:text-6xl text-[#12281a] leading-[1.02] uppercase mb-6" data-testid="projects-headline">
            Selected Projects
          </h1>
          <p className="text-xl text-[#2c382f] font-light leading-snug max-w-3xl">
            A curated record — communities delivered by Apratim Group in Chhatrapati Sambhaji Nagar, and the
            next chapter now unfolding in Pune.
          </p>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="space-y-8">
            {PROJECTS.map((p, i) => (
              <Reveal key={p.slug} delay={i * 80}>
                <ProjectCard project={p} index={i} />
              </Reveal>
            ))}
          </div>
          <Reveal delay={200}>
            <p className="mt-16 text-xs text-[#12281a]/50 uppercase tracking-widest text-center">
              Only publicly approved project information is published on this website.
            </p>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
